/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../../utils/styles/general';



/* ++++++++++ --------------- ASIDE TOGGLE : STYLES --------------- ++++++++++ */
export default {
	asidetoggle: {
		'& .icon': {
			borderRadius: pxToEm(12),
			color: themeV2.color.base.gray.dark,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: pxToEm(36),
			width: pxToEm(36),
			extend: hoverTransition(),
			'&.name-arrow-right': {
				background: `rgb(243, 249, 254)`
			}
		},
		'&.sidebarOpen': {
			'&-true': {
				'& .icon': {
					'&:hover': { 
						color: 'rgba(6, 43, 117, 0.8)'
					}
				}
			},
			'&-false': {
				'& .icon': {
					'&:hover': { 
						color: 'rgba(6, 43, 117, 0.8)',
						filter: 'brightness(97%)' 
					}
				}
			}
		}
	}
}; 